(function($){
  $(document).on('click', '.cpb-layout .cpb-panels-tabs .cpb-panel-categories-container .cpb-category-options-container:not(.inputLong) .option' ,function(){
    $(this).parent().toggleClass('open');
    $(this).prependTo($(this).parent());
  });

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
    customtrigger();
    $('.custom-product-preloader').remove();
    $('.product-badges').insertBefore('.cpb-product-title');
    $('.product-badges-mobile').appendTo('.cpb-preview-layers');
    $('.eyebrow-text').insertBefore('.cpb-product-title');
    $('<div class="product-price-reviews-block"></div>').insertAfter('.cpb-product-title');
    $('.cpb-product-price').appendTo('.product-price-reviews-block');
    $('.product-details-block').insertAfter('.cpb-product-actions');
    $('.share-button').insertAfter('.product-details-block');
    $('.short-description').insertAfter('.cpb-product-title');
    $('.breadcrumb').insertBefore('.cpb-product-builder');

    if($('[id^="MainProduct-template"] .price--on-sale').length) {
      $('<div class="product-price__sale"></div>').appendTo('.product-price-reviews-block');
      $('.cpb-product-price').appendTo('.product-price__sale');
      $('.price--on-sale .price__sale .price-item--regular').insertAfter('.cpb-product-price');

      var regPrice = $('.product-price__sale .price-item--regular').text().replace('$', '');
      $(document).on('DOMSubtreeModified', '.product-price__sale .cpb-product-price', function() {
        var quantityCount = $('.cpb-quantity-value').val(),
          updatedRegPrice = (regPrice * quantityCount).toFixed(2);

        $('.product-price__sale .price-item--regular').text('$' + updatedRegPrice);
      });
    }

    if($('.cpb-agreement-label').length) {
      var labelText = $('.cpb-agreement-title').text();
      $('.cpb-agreement-label .cpb-agreement-checkbox').attr({id:'agreement_checkbox', disabled:'disabled'}).parent().addClass('disabled');
      $('<label for="agreement_checkbox">' + labelText + '</label>').insertAfter('.cpb-agreement-label .cpb-agreement-checkbox');

      if(!$('#agreement_checkbox').is(':checked')) {
        $('.cpb-add-to-cart-button').attr('disabled', 'disabled');
      }
    }

    if($('.outOfStockProduct').length) {
      $('.cpb-product-actions-container button.cpb-add-to-cart-button').addClass('disable-out-of-stock');
      $('.cpb-product-actions-container button.cpb-add-to-cart-button span').text('Out of Stock');
    }

    $("body").on("click", ".cpb-agreement-label", function(){
      if(!$('#agreement_checkbox').is(':checked')) {
        $('.cpb-add-to-cart-button').attr('disabled', 'disabled');
      } else {
        $('.cpb-add-to-cart-button').removeAttr('disabled');
      }
    });

    if($('.cpb-agreement-description').length && !$('.scroll-note').length) {
      $('<span class="scroll-note">Scroll to accept terms</span>').appendTo('.cpb-agreement-description');
    }

    $("body").on("DIVscroll", ".cpb-agreement-description", function(){
      if (parseInt($(this).scrollTop()) >= (parseInt($(this)[0].scrollHeight) - parseInt($(this).innerHeight()) - 10)) {
        $('.cpb-agreement-label .cpb-agreement-checkbox').removeAttr('disabled').parent().removeClass('disabled');
        $('.scroll-note').fadeOut('300', function(){
          $(this).remove();
        });
      }
    });

    ScrollEventListener($('.cpb-agreement-description'));

    function ScrollEventListener(el){
      el.on("scroll", function(){
        el.trigger("DIVscroll");
      });
    }

    setTimeout(() => {
      const starRating = document.querySelector('[data-oke-star-rating]')
      const productPriceBlock = document.querySelector('.product-price-reviews-block')
      productPriceBlock.append(starRating)
    }, 1000);
  });


  $(document).on('keyup keypress', '.single-line-field textarea', function(e) {
    var keyCode = e.keyCode || e.which;
    if (keyCode === 13) {
      e.preventDefault();
      return false;
    }
  });

  $(document).ready(function(){
    if ($('.slider-dots').length) {
      $('.product__media-wrapper').addClass('has-images');
    }
  });
  document.addEventListener('cpb-add-to-cart', function() {
    const btnSubmit = document.querySelector('.product-form__submit');
    const qtyInput = document.querySelector('quantity-input input');
    if(btnSubmit && qtyInput) {
      qtyInput.value = 0;
      btnSubmit.click();
    }
  });

  
  function customtrigger(){
    $('.collapsto_section').addClass("customgiftwidth-long");
    $('.collapsto_section').removeClass("customgiftwidth-short");
    $('.collapsmessage_section').hide();
    $('.collapsfrom_section').hide();
    $('.collapsto_section').find('.cpb-category-options-container').hide();
    $('.collapse_to_title').hide();
  }
  $(document).on('click', '#custom_cgsCheck' ,function(){
    if(!$('#custom_cgsCheck').is(':checked')) {
      $('.collapsto_section').addClass("customgiftwidth-long");
      $('.collapsto_section').removeClass("customgiftwidth-short");
      $('.collapsmessage_section').hide();
      $('.collapsfrom_section').hide();
      $('.collapsto_section').find('.cpb-category-options-container').hide();
      $('.collapse_to_title').hide();
    } else {
      $('.collapsto_section').removeClass("customgiftwidth-long");
      $('.collapsto_section').addClass("customgiftwidth-short");
      $('.collapsmessage_section').show();
      $('.collapsfrom_section').show();
      $('.collapsto_section').find('.cpb-category-options-container').show();
      $('.collapse_to_title').show();
    }
  });

})(jQuery);